export default {
  loggedIn: {
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    balance: 'Total Balance',
    cash: 'Cash',
    bonus: 'Bonus',
    withdrawable: 'Withdrawable',
    transaction: 'Transaction',
    history: 'History',
    myBet: 'My Bet',
    rollover: 'Rollover',
    vault: 'Vault',
    notification: 'Notification',
    affiliate: 'Agent - Earn $5,000 Per Month',
    affiliateTitle: 'Agent',
    affiliateBadge: 'Earn $5,000 Per Month',
    settings: 'Settings',
    currency: 'Currency',
    language: 'Language',
    liveSupport: 'Live Support',
    taskReward: 'Tasks',
    redeemCode: 'Redeem Code',
    customerService: 'Customer Service',
    accountSecurity: 'Security',
    signOut: 'Sign Out'
  }
};
